/*
 * --collapsible-panel-height is set by Base UI as an inline style on the panel (the measured content height,
 * "auto" before measuring); the starting/ending styles collapse it to 0.
 */
.collapsible {
	height: var(--collapsible-panel-height);
	overflow: hidden;
	transition: height 200ms ease-out;

	&[data-starting-style],
	&[data-ending-style] {
		height: 0;
	}

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}
}
